
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms'

import { CommonModule } from '@angular/common';
import { MmEntityFormDirective } from './entity-form.directive';
import { MmRequiredMessageComponent } from './required-message';
import { MmFormErrorComponent } from './form-error/form-error.component';
import { FormItemComponent } from './form-item/form-item.component';
import { NzFormModule } from 'ng-zorro-antd/form'

@NgModule({
    imports: [CommonModule, FormsModule, ReactiveFormsModule, NzFormModule],
    exports: [FormsModule, ReactiveFormsModule, MmRequiredMessageComponent, MmFormErrorComponent, FormItemComponent],
    declarations: [MmEntityFormDirective, MmRequiredMessageComponent, MmFormErrorComponent, FormItemComponent],
    providers: []
})
export class MmFormsModule {


}
